module.exports = __webpack_public_path__ + "static/media/SFMono-Medium.99497ab6.woff2";